import HorizontalRule from 'components/Layout/HorizontalRule';
import { TwoColumnWithBookingSummary } from 'components/Layout';
import useScrollTopOnMount from 'hooks/useScrollTopOnMount';
import ConfirmationInfo from './ConfirmationInfo';
import ContactUsWithReference from './ContactUsWithReference';
import RequestDetails from '../RequestDetails';
import ButtonGroup from 'components/ButtonGroup';
import { useChangeDatesRequestFlow } from '../ChangeDatesRequestFlowProvider';

const RequestConfirmation = () => {
  const { booking, values, caseNumber, goToBookingDetails } = useChangeDatesRequestFlow();
  const { checkIn, checkOut, phoneNumber, email } = values;

  useScrollTopOnMount();

  if (!booking || !caseNumber) {
    return null;
  }

  return (
    <TwoColumnWithBookingSummary heading="Your date change request has been sent">
      <ConfirmationInfo caseNumber={caseNumber} email={email} propertyName={booking.reservation.property.name} />
      <RequestDetails mt={[7, 8]} checkIn={checkIn} checkOut={checkOut} phoneNumber={phoneNumber} email={email} />
      <ButtonGroup
        mt={7}
        desktopBackLabel="Return to manage your booking"
        mobileBackLabel="Manage your booking"
        onClickBack={goToBookingDetails}
        withBackIcon={false}
        continueLabel=""
        onClickContinue={null}
        continueButtonProps={{ display: 'none' }}
        CustomContinueButton={null}
      />
      <HorizontalRule mt={7} mb={0} mx={0} />
      <ContactUsWithReference caseNumber={caseNumber} mt={[7, 8]} />
    </TwoColumnWithBookingSummary>
  );
};

export default RequestConfirmation;
